export const BOX_PINK = "/assets/mix-chocolate.png";
export const BOX_GREEN = "/assets/mix-vanilla.png";

const img = (id) =>
  `https://images.unsplash.com/${id}?q=80&w=1200&auto=format&fit=crop`;

export const IMAGES = {
  chocCake: img("photo-1578985545062-69928b1d9587"),
  vanillaCake: img("photo-1621303837174-89787a7d4729"),
  almonds: img("photo-1508061253366-f7da158b6d46"),
  chocolate: img("photo-1481391319762-47dff72954d9"),
  baking: img("photo-1556910103-1c02745aae4d"),
  berries: img("photo-1565958011703-44f9829ba187"),
  cupcakes: img("photo-1587668178277-295251f900ce"),
  loaf: img("photo-1607478900766-efe13248b125"),
  sprinkle: img("photo-1464349095431-e9a21285b5f3"),
};

export const PRODUCTS = [
  {
    id: "vanilla",
    flavor: "Vanilla",
    title: "Almond Flour Cake Mix",
    boxImg: BOX_GREEN,
    cakeImg: IMAGES.vanillaCake,
    panel: "bg-[#D1E8E2]",
    ribbon: "bg-[#2A524A] text-[#D1E8E2]",
    chipBorder: "border-[#2A524A]/25 text-[#2A524A]",
    accentText: "text-[#2A524A]",
    blurb:
      "Light, fragrant and made with ingredients that you can trust. Our vanilla mix blends certified organic almond flour, organic coconut sugar and organic vanilla bean powder into a soft, delicate crumb — no refined sugar, no gluten, no preservatives.",
    ingredients: [
      "Organic almond flour",
      "Organic coconut sugar",
      "Organic coconut flour",
      "Organic arrowroot powder",
      "Organic vanilla bean powder",
      "100% pure food-grade baking soda",
      "Organic Himalayan pink salt",
    ],
    facts: [
      ["Yield", "One 6″ cake · 10 slices"],
      ["Prep", "5 minutes, one bowl"],
      ["Bake", "180°C · 25–30 min"],
      ["Protein", "2.9 g per slice"],
      ["Net weight", "250 g"],
    ],
    nutrition: {
      columns: ["Nutrient", "Per 100 g", "Per 25 g", "% RDA*"],
      rows: [
        ["Energy", "512 kcal", "128 kcal", "6%"],
        ["Protein", "11.49 g", "2.87 g", "—"],
        ["Carbohydrate", "57.59 g", "14.40 g", "—"],
        ["Total sugars", "38.02 g", "9.51 g", "—"],
        ["Added sugars", "34.32 g", "8.58 g", "17%"],
        ["Total fat", "26.15 g", "6.54 g", "10%"],
        ["Saturated fat", "2.79 g", "0.70 g", "3%"],
        ["Trans fat", "<0.01 g", "<0.003 g", "<1%"],
        ["Sodium", "514.61 mg", "128.65 mg", "6%"],
      ],
      note: "Serving size 25 g dry mix · 10 servings per pack · *% of adult RDA per 25 g serving · values for the dry mix only",
    },
  },
  {
    id: "chocolate",
    flavor: "Chocolate",
    title: "Almond Flour Cake Mix",
    boxImg: BOX_PINK,
    cakeImg: null,
    panel: "bg-[#F8C8DC]",
    ribbon: "bg-[#6A2C3E] text-[#F8C8DC]",
    chipBorder: "border-[#6A2C3E]/25 text-[#6A2C3E]",
    accentText: "text-[#6A2C3E]",
    blurb:
      "Deep, fudgy and made with ingredients that you can trust. Our chocolate mix blends certified organic almond flour, organic coconut sugar and organic cacao into a rich, tender crumb — no refined sugar, no gluten, no preservatives.",
    ingredients: [
      "Organic almond flour",
      "Organic coconut sugar",
      "Organic coconut flour",
      "Organic arrowroot powder",
      "Organic cacao",
      "100% pure food-grade baking soda",
      "Organic Himalayan pink salt",
    ],
    facts: [
      ["Yield", "One 6″ cake · 10 slices"],
      ["Prep", "5 minutes, one bowl"],
      ["Bake", "180°C · 25–30 min"],
      ["Protein", "3.8 g per slice"],
      ["Net weight", "250 g"],
    ],
    nutrition: {
      columns: ["Nutrient", "Per 100 g", "Per 25 g", "% RDA*"],
      rows: [
        ["Energy", "483 kcal", "121 kcal", "6%"],
        ["Protein", "15.25 g", "3.81 g", "—"],
        ["Carbohydrate", "59.32 g", "14.83 g", "—"],
        ["Total sugars", "34.27 g", "8.57 g", "—"],
        ["Added sugars", "31.60 g", "7.90 g", "16%"],
        ["Total fat", "20.49 g", "5.12 g", "8%"],
        ["Saturated fat", "2.44 g", "0.61 g", "3%"],
        ["Trans fat", "<0.01 g", "<0.003 g", "<1%"],
        ["Sodium", "273.46 mg", "68.37 mg", "3%"],
      ],
      note: "Serving size 25 g dry mix · 10 servings per pack · *% of adult RDA per 25 g serving · values for the dry mix only",
    },
  },
];

export const CHAPTERS = [
  {
    num: "01",
    title: "We use organic almond flour",
    sub: "The heart of every mix.",
    points: [
      ["100% Blanched Almonds", "Stone-milled super fine for a soft, tender crumb."],
      ["Naturally Gluten-Free", "No wheat, no fillers — just almonds, nothing else."],
      ["High in Protein", "A flour that nourishes, not just fills."],
      ["Rich in Vitamin E", "Good fats and natural goodness in every slice."],
    ],
    badges: ["Certified Organic", "100% Almonds", "Gluten Free", "High Protein", "No Additives", "Vegan"],
    img: "/assets/almond-flour-bowl.png",
    alt: "Bowl of finely milled organic almond flour with whole almonds spilled beside it on linen",
  },
  {
    num: "02",
    title: "We use organic coconut sugar",
    sub: "Better ingredients, healthier you.",
    points: [
      ["100% Organic", "Made from the sap of coconut palm flowers."],
      ["Low Glycemic Index", "A better choice for balanced energy."],
      ["Rich in Minerals", "Contains essential minerals like potassium, iron & zinc."],
      ["Unrefined & Natural", "Minimally processed to retain natural goodness."],
    ],
    badges: ["Certified Organic", "Organic", "Gluten Free", "Preservative Free", "Vegan", "High in Minerals"],
    img: "/assets/coconut-sugar.png",
    alt: "Bowl of organic coconut sugar beside a fresh coconut half and almonds",
  },
  {
    num: "03",
    title: "Five-minute magic",
    text: "One bowl, one whisk, five minutes of prep. Baking together should feel like play, not a project — so we did the measuring, sifting and stressing for you.",
    img: "https://images.pexels.com/photos/8511845/pexels-photo-8511845.jpeg?auto=compress&cs=tinysrgb&w=1600",
    alt: "Two young Indian boys in aprons and chef hats playing with flour while baking",
  },
];

export const RECIPES = [
  {
    id: "shortcake",
    title: "Vanilla Berry Shortcake",
    mix: "Vanilla Mix",
    time: "25 min",
    level: "Easy",
    img: IMAGES.berries,
    need: ["1 box Vanilla mix", "3 eggs", "80 g melted butter", "200 g macerated berries", "Whipped cream"],
    steps: [
      "Heat the oven to 170°C and line an 8″ round pan.",
      "Whisk eggs and butter into the mix until just combined — 60 seconds, no more.",
      "Bake 28–32 minutes until golden and springy. Cool 10 minutes.",
      "Split, fill with whipped cream and berries, and dust with coconut sugar.",
    ],
  },
  {
    id: "cupcakes",
    title: "Midnight Fudge Cupcakes",
    mix: "Chocolate Mix",
    time: "30 min",
    level: "Easy",
    img: IMAGES.cupcakes,
    need: ["1 box Chocolate mix", "3 eggs", "80 g melted butter", "Flaky sea salt"],
    steps: [
      "Heat the oven to 170°C and line a 12-cup muffin tin.",
      "Whisk eggs and butter into the mix until glossy.",
      "Fill cups two-thirds full and bake 18–20 minutes.",
      "Finish warm with a pinch of flaky sea salt — trust us.",
    ],
  },
  {
    id: "loaf",
    title: "Espresso Almond Loaf",
    mix: "Chocolate Mix",
    time: "45 min",
    level: "Medium",
    img: IMAGES.loaf,
    need: ["1 box Chocolate mix", "3 eggs", "2 shots espresso, cooled", "80 g melted butter", "Toasted almonds"],
    steps: [
      "Heat the oven to 170°C and line a loaf pan.",
      "Whisk eggs, espresso and butter into the mix.",
      "Bake 38–42 minutes until a skewer comes out with moist crumbs.",
      "Glaze with espresso icing and scatter toasted almonds.",
    ],
  },
  {
    id: "sprinkle",
    title: "Celebration Sprinkle Cake",
    mix: "Vanilla Mix",
    time: "40 min",
    level: "Medium",
    img: IMAGES.sprinkle,
    need: ["1 box Vanilla mix", "3 eggs", "80 g melted butter", "Natural sprinkles", "Cream-cheese frosting"],
    steps: [
      "Heat the oven to 170°C and line an 8″ round pan.",
      "Whisk eggs and butter into the mix, then fold in sprinkles.",
      "Bake 28–32 minutes and cool completely.",
      "Frost generously, add more sprinkles, and make a wish.",
    ],
  },
];

export const REVIEWS = [
  {
    quote:
      "My kids licked the bowl, the whisk, and honestly the counter. Nobody at the table believed it was gluten-free — the crumb is that good.",
    name: "Priya Reddy",
    role: "Home baker, mum of two",
    stars: 5,
    big: true,
  },
  {
    quote: "The vanilla mix tastes like something from a fancy bakery. That almond crumb is unreal.",
    name: "Ananya Iyer",
    role: "Weekend baker",
    stars: 5,
  },
  {
    quote: "Finally a mix I can hand to my celiac sister without a twenty-minute ingredient lecture.",
    name: "Kavita Rao",
    role: "Gluten-free household",
    stars: 5,
  },
];

export const FAQS = [
  {
    q: "Are the mixes really gluten-free?",
    a: "Yes. Both mixes are built on organic almond flour — no wheat, barley or rye anywhere in the recipe. Every batch is produced with strict gluten-free handling.",
  },
  {
    q: "Is there any refined sugar?",
    a: "None. We sweeten with coconut sugar only, which brings a gentle caramel note and a lower glycaemic load than white sugar. Each slice lands around 9 g of total sugar.",
  },
  {
    q: "Oven, cooker, air fryer or microwave — how do I bake it?",
    a: "All four work. Oven: 180°C for 25–30 mins in a greased 6-inch pan. Pressure cooker: preheat 5 mins without the whistle, then low heat for 25–30 mins. Air fryer: 160°C for 18–22 mins in a tin that fits your basket. Microwave: medium power for 5–7 mins. Full instructions are printed on every box.",
  },
  {
    q: "Can I bake it egg-free or dairy-free?",
    a: "Absolutely. Swap the 3 eggs for 3 flax eggs (1 tbsp ground flax + 3 tbsp water each) and use coconut oil instead of butter. The crumb stays tender.",
  },
  {
    q: "How long does a box stay fresh?",
    a: "Sealed boxes keep 9 months in a cool, dry cupboard. Once baked, the cake stays moist for 3 days under a cover — if it survives that long.",
  },
  {
    q: "How long does delivery take?",
    a: "Orders are packed and shipped within 1–2 business days, and reach most pincodes in 3–6 business days across India. You'll get tracking by email the moment your box leaves our kitchen.",
  },
];

export const MARQUEE_ITEMS = [
  "Wholesome Ingredients",
  "Certified Organic",
  "Delicious Bakes",
  "No Refined Sugar",
  "Gluten Free",
  "High Protein",
  "Made with 7 Ingredients",
  "5-Minute Prep",
];
